import { Middleware } from "openapi-fetch";
import type { paths as V2Paths } from "./v2/types";
import type { paths as V3Paths } from "./v3/types";
import type { paths as DfJobStatusPaths } from "./df-job-status/types";
import type { paths as DfJobPlanningPaths } from "./df-job-planning/types";
import type { paths as DfGeneOntologyPaths } from "./df-gene-ontology/types";
import type { paths as DfSearchedPaths } from "./df-searched/types";
import type { paths as DfUserPaths } from "./user/types";
import createFetchClient from "openapi-fetch";
import { validateAccessToken } from "./auth.ts";

const baseUrl = import.meta.env.VITE_BASE_API_URL;

// 모든 API 경로를 하나로 통합
export interface UnifiedPaths
  extends V2Paths,
    V3Paths,
    DfJobStatusPaths,
    DfJobPlanningPaths,
    DfGeneOntologyPaths,
    DfSearchedPaths,
    DfUserPaths {}

const authMiddleware: Middleware = {
  async onRequest({ request }) {
    const accessToken = await validateAccessToken();

    request.headers.set("Authorization", `${accessToken}`);
    return request;
  },
};

export const client = createFetchClient<UnifiedPaths>({ baseUrl });

client.use(authMiddleware);
